<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in" (click)="closeDropdowns()">
  <div class="relative w-full max-w-lg bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 p-6 md:p-8 animate-fade-in-up max-h-[90vh] overflow-y-auto" (click)="onClickInsideModal($event)">

    <div *ngIf="isLoading()" class="absolute inset-0 bg-white/70 dark:bg-slate-900/70 backdrop-blur-xs z-50 flex items-center justify-center rounded-[2rem]">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
    </div>

    <div class="flex items-center justify-between mb-6 pb-4 border-b border-slate-100 dark:border-slate-800">
      <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">menu_book</span>
        {{ formData.id ? 'แก้ไขเมนูของ Role' : 'เพิ่มเมนูให้ Role' }}
      </h3>
      <button (click)="onClose()" class="w-8 h-8 rounded-lg flex items-center justify-center text-slate-400 hover:text-slate-600 hover:bg-slate-50 transition-colors">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="space-y-5">
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div class="p-3 bg-amber-50 dark:bg-amber-900/20 rounded-xl border border-amber-100 dark:border-amber-800/30">
          <p class="text-xs font-bold text-amber-600 dark:text-amber-400 uppercase tracking-wider mb-1">Role</p>
          <p class="text-sm font-bold text-slate-700 dark:text-slate-200">{{ roleName }}</p>
        </div>
        <div *ngIf="groupSubName" class="p-3 bg-sky-50 dark:bg-sky-900/20 rounded-xl border border-sky-100 dark:border-sky-800/30">
          <p class="text-xs font-bold text-sky-600 dark:text-sky-400 uppercase tracking-wider mb-1">กลุ่มเมนูย่อย</p>
          <p class="text-sm font-bold text-slate-700 dark:text-slate-200">{{ groupSubName }}</p>
        </div>
      </div>

      <!-- Custom Menu list Searchable Dropdown -->
      <div class="relative">
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">รายการเมนู <span class="text-rose-500">*</span></label>
        <div class="relative w-full flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:bg-white focus-within:ring-2 focus-within:ring-amber-200 transition-all overflow-hidden h-[46px]"
          (click)="$event.stopPropagation()">
          <span class="absolute left-3 material-icons text-slate-400">list_alt</span>
          <input type="text" placeholder="พิมพ์เพื่อค้นหา..." [(ngModel)]="searchMenuText"
            [disabled]="!!formData.id || isOptionsLoading()" (focus)="onInputFocus('menuList')" (blur)="closeDropdowns()"
            class="w-full pl-10 pr-10 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:ring-0 focus:outline-none placeholder:text-slate-400 disabled:opacity-60">
          <button type="button" (click)="toggleDropdown('menuList', $event)" [disabled]="!!formData.id || isOptionsLoading()" class="absolute right-2 text-slate-400 hover:text-slate-600 outline-none disabled:opacity-60">
            <span class="material-icons text-lg transition-transform duration-200" [class.rotate-180]="openDropdown === 'menuList'">expand_more</span>
          </button>
        </div>

        <!-- Custom Dropdown Overlay -->
        <div *ngIf="openDropdown === 'menuList'" (mousedown)="$event.preventDefault()" (click)="$event.stopPropagation()"
          class="absolute top-full left-0 mt-2 w-full bg-white dark:bg-slate-800 rounded-2xl shadow-2xl border border-slate-100 dark:border-slate-700 max-h-48 overflow-y-auto z-45 py-2 custom-scrollbar">
          <div *ngFor="let opt of filteredMenuListOptions" (click)="selectMenu(opt)"
            class="px-4 py-2 text-sm font-semibold hover:bg-amber-50 dark:hover:bg-amber-900/10 cursor-pointer transition-colors flex items-center justify-between"
            [ngClass]="formData.menuListId === opt.id ? 'text-amber-500 bg-amber-50 dark:bg-amber-900/10' : 'text-slate-600 dark:text-slate-300'">
            {{ opt.name }}
            <span *ngIf="formData.menuListId === opt.id" class="material-icons text-sm">check</span>
          </div>
          <div *ngIf="filteredMenuListOptions.length === 0" class="px-4 py-3 text-xs text-slate-400 text-center font-bold">ไม่พบข้อมูลเมนู</div>
        </div>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ชื่อแสดง (ไม่บังคับ)</label>
        <div class="relative w-full flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:bg-white focus-within:ring-2 focus-within:ring-amber-200 transition-all overflow-hidden h-[46px]">
          <span class="absolute left-3 material-icons text-slate-400">label</span>
          <input type="text" placeholder="ชื่อแสดงในระบบ" [(ngModel)]="formData.name"
            class="w-full pl-10 pr-4 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:ring-0 focus:outline-none placeholder:text-slate-400">
        </div>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-3">สิทธิ์เมนู</label>
        <div class="grid grid-cols-2 gap-3">
          <label class="flex items-center gap-3 p-3 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-100 dark:border-slate-800 opacity-60 cursor-not-allowed">
            <input type="checkbox" [ngModel]="formData.canView" disabled class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400">
            <span class="text-sm font-medium text-slate-700 dark:text-slate-300">ดู (View)</span>
          </label>
          <label class="flex items-center gap-3 p-3 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-100 dark:border-slate-800 cursor-pointer hover:border-amber-300 transition-colors">
            <input type="checkbox" [(ngModel)]="formData.canCreate" class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400">
            <span class="text-sm font-medium text-slate-700 dark:text-slate-300">สร้าง</span>
          </label>
          <label class="flex items-center gap-3 p-3 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-100 dark:border-slate-800 cursor-pointer hover:border-amber-300 transition-colors">
            <input type="checkbox" [(ngModel)]="formData.canEdit" class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400">
            <span class="text-sm font-medium text-slate-700 dark:text-slate-300">แก้ไข</span>
          </label>
          <label class="flex items-center gap-3 p-3 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-100 dark:border-slate-800 cursor-pointer hover:border-amber-300 transition-colors">
            <input type="checkbox" [(ngModel)]="formData.canDelete" class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400">
            <span class="text-sm font-medium text-slate-700 dark:text-slate-300">ลบ</span>
          </label>
          <label class="flex items-center gap-3 p-3 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-100 dark:border-slate-800 cursor-pointer hover:border-amber-300 transition-colors col-span-2">
            <input type="checkbox" [(ngModel)]="formData.canAction" class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400">
            <span class="text-sm font-medium text-slate-700 dark:text-slate-300">Action</span>
          </label>
        </div>
      </div>
    </div>

    <div class="flex items-center justify-between gap-3 mt-8 pt-4 border-t border-slate-100 dark:border-slate-800">
      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()"
        class="px-5 py-2.5 border border-slate-200 dark:border-slate-700 hover:border-amber-400 hover:text-amber-600 text-slate-600 dark:text-slate-300 font-bold rounded-xl shadow-sm transition-all active:scale-95 inline-flex items-center gap-1.5 cursor-pointer">
        <span class="material-icons text-base">history</span>
        ดูประวัติ
      </button>
      <div class="flex items-center justify-end gap-3 ml-auto">
        <button (click)="onClose()" class="px-5 py-2.5 bg-slate-50 dark:bg-slate-800 hover:bg-slate-100 text-slate-500 dark:text-slate-400 font-bold rounded-xl shadow-sm transition-all active:scale-95">ยกเลิก</button>
        <button (click)="onSave()" class="px-6 py-2.5 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl shadow-lg hover:shadow-amber-400/20 hover:-translate-y-0.5 transition-all active:scale-95">บันทึก</button>
      </div>
    </div>
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && formData.id"
  [entityType]="activityEntityTypes.MenuRole"
  [entityId]="formData.id!"
  title="ประวัติ Menu Role"
  [subtitle]="'#' + formData.id"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>
